exports = module.exports = require('./commonjs/readXlsxFileBrowser').default
exports.convertToJson = require('./commonjs/convertToJson').default
exports.Integer = require('./commonjs/types/Integer').default
exports.Email = require('./commonjs/types/Email').default
exports.URL = require('./commonjs/types/URL').default
exports.parseExcelDate = require('./commonjs/parseDate').default
exports['default'] = require('./commonjs/readXlsxFileBrowser').default


//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/index.commonjs.js
// module id = 2001
// module chunks = 1